function u(n, i) {
  return n && n[i] ? n[i] : null;
}
function r(n, i) {
  const l = (n == null ? void 0 : n.evaluatedFlags) || {};
  if (i in l)
    return !!l[i];
  const t = u(n, i);
  return t ? t.enabled : !1;
}
export {
  u as findFeatureValue,
  r as findFeatureVisibility
};
//# sourceMappingURL=utils.js.map
